import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import SectionTitle from "@/components/base/SectionTitle";
import { philosophy, timeline } from "@/mocks/company";

export default function About() {
  return (
    <Layout>
      <PageHero
        eyebrow="About Us"
        title="私たちについて"
        description="20年の現場経験と、オーナー視点。株式会社DAISANが大切にしていることを、ご紹介します。"
        image="images/us.webp"
      />

      <section className="bg-background-50 py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-4 md:px-10 text-center">
          <p className="text-xs tracking-[0.3em] uppercase text-accent-700 mb-4">Mission</p>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight mb-8">
            「きれい」を、<br />
            長く続けられる形で。
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
            一度だけピカピカにするのは、実は難しくありません。難しいのは、5年後・10年後も、
            お客様が「頼んでよかった」と感じ続けられる関係を作ること。
          </p>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            そのために私たちは、清掃技術だけでなく、不動産・資産・地域との関わり方まで含めて、
            お客様と一緒に考えていく清掃会社でありたいと思っています。
          </p>
        </div>
      </section>

      <section className="bg-background-100 py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 md:px-10">
          <SectionTitle eyebrow="Philosophy" title="私たちの3つの約束" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
            {philosophy.map((p) => (
              <div key={p.title} className="bg-background-50 rounded-lg border border-background-200 p-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 mb-5">
                  <i className={`${p.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-3">{p.title}</h3>
                <p className="text-sm text-foreground-700 leading-relaxed text-justify">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-4 md:px-10">
          <SectionTitle eyebrow="History" title="これまでの歩み" />
          <div className="relative border-l-2 border-accent-300 pl-6 md:pl-10 space-y-8">
            {timeline.map((t) => (
              <div key={t.year} className="relative">
                <span className="absolute -left-[34px] md:-left-[46px] top-1 w-4 h-4 rounded-full bg-accent-500 border-4 border-background-50"></span>
                <div className="font-heading text-primary-700 text-xl mb-1">{t.year}</div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{t.event}</p>
              </div>
            ))}
          </div>

          <div className="mt-14 text-center">
            <Link
              to="/company"
              className="inline-flex items-center gap-2 border border-primary-600 text-primary-700 hover:bg-primary-500 hover:text-background-50 px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              会社情報を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}